// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/investment-advice.scss
// module id = 445
// module chunks = 0